export default __webpack_public_path__ + "static/media/logo_icon.4500b3ab.svg";